import {
    FETCH_LOCATION_BASED_DUTYTYPE_REQUEST,
    FETCH_LOCATION_BASED_DUTYTYPE_SUCCESS,
    FETCH_LOCATION_BASED_DUTYTYPE_FAILURE,
} from "../constants/LocationBasedDutyTypeConstants";

const initialState = {
    loading: false,
    data: [],
    error: null,
};

const LocationBasedDutyTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_LOCATION_BASED_DUTYTYPE_REQUEST:
            return { ...state, loading: true, error: null };

        case FETCH_LOCATION_BASED_DUTYTYPE_SUCCESS:
            return { ...state, loading: false, data: action.payload, error: null };

        case FETCH_LOCATION_BASED_DUTYTYPE_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
};

export default LocationBasedDutyTypeReducer;